import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

// August 6th: refactored for responsiveness
const NationalQualifying = () => {
    return (
        <div className="w3-container w3-content pt-8 pb-8" id="nationals">
            <div className="d-flex flex-row">
                <div className="w-100 d-flex flex-column justify-content-center">
                    <Title text="National Qualifying" />
                    <p className="margin-top gray hind">A team can qualify to participate in the Challenge Sports 3v3 National Championships in these ways:</p>
                    <p className="gray hind">1. Finish within the top 4 teams in your age division at any one of the local qualifying events throughout the country.</p>
                    <p className="gray hind">2. Finish within the top 6 teams in your age division at any 3v3 Super Challenge, the Disney 3v3 Championships, the USA 3v3 Nationals or the prior year's Nationals.</p>
                    <p className="gray hind">3. Finish first within a Gold Division at Nationals within the past 2 years.</p>
                    <p className="gray hind">4. Second Chance: Teams that have participated in three (3) or more Events in a Tour Season, but did not qualified in those, will be allowed to register and play at Nationals but only in the 2nd Division.</p>
                </div>
                <div style={{ width: 30 }} />
                <ScrollAnimation animateIn="fadeInUp" animateOnce={true} className="w-100">
                    <img alt="" className="w-100" src="/images/others/nat-qual.png" />
                </ScrollAnimation>
            </div>
        </div>
    );
}

export default NationalQualifying;



// WEBPACK FOOTER //
// ./src/components/information/partials/national_qualifying.js